import { createAction, props } from '@ngrx/store';
import { OrgStaffUserInterface, OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';


export const loadStaff = createAction('[Staff] Load Staff');

export const loadStaffsSuccess = createAction(
  '[Staff] Load Staff Success',
  props<{ staff: OrgStaffUserInterfaceWithId[] }>()
);

export const loadStaffsFailure = createAction(
  '[Staff] Load Staffs Failure',
  props<{ error: any }>()
);

// ADD STAFF
export const addStaff = createAction(
  '[Staff] add staff',
  props<{ staff: OrgStaffUserInterfaceWithId }>()
);


export const addStaffSuccess = createAction(
  '[Staff] added with success',
  props<any>()
);

export const addStaffError = createAction(
  '[Staff] added failed',
  props<{ error: Error }>()
);


// REMOVE STAFF
export const removeStaff = createAction(
  '[Staff] removed',
  props<{
    id: string,
  }>()
);

export const removeStaffSuccess = createAction(
  '[Staff] removed with success',
  props<any>()
);

export const removeStaffError = createAction(
  '[Staff] removed failed',
  props<{ error: Error }>()
);


// UPDATE STAFF
export const updateStaff = createAction(
  '[Staff] update',
  props<{
    id: string,
    changes: OrgStaffUserInterfaceWithId
  }>()
);


export const updateStaffSuccess = createAction(
  '[Staff] update success',
  props<any>()
);

export const updateStaffError = createAction(
  '[Staff] update failed',
  props<{ error: Error }>()
);


// FIRESTORE ACTIONS

export const queryFireStoreStaff = createAction(
  '[Staff] query staff',
  props<any>()
);


export const queryFireStoreStaffError = createAction(
  '[Staff] error at query staff',
  props<{ error: Error }>()
);


export const fromFireStoreAddStaff = createAction(
  '[Staff] added by Firestore',
  props<{ staff: OrgStaffUserInterfaceWithId }>()
);


export const fromFireStoreModifyStaff = createAction(
  '[Staff] modified by Firestore',
  props<{ staff: OrgStaffUserInterfaceWithId }>()
);
export const fromFireStoreRemoveStaff = createAction(
  '[Staff] removed by Firestore',
  props<{
    id: string,
  }>()
);



